import { makeNetworkRequest } from "./networkUtils";

export const triggerPrivilegesFunction = async (httpRequestType, postData, authorizationToken, endPoint) => {
    let fullEndpoint = `/users/privileges/${endPoint}`;
    let response = await makeNetworkRequest(httpRequestType, fullEndpoint, authorizationToken, postData);
    if(response) {
        return response;
    } else {
        return false;
    }
};

export const getPrivileges = async (email, accessToken) => {
    let privileges = await triggerPrivilegesFunction("post", { email }, accessToken, "get");
    let result = false;
    if(privileges) {
        result = privileges;
    }
    return result;
};
  
export const updatePrivileges = async (userId, isAdmin, accessToken) => {
    let updatedPrivacyPreferences = await triggerPrivilegesFunction("post", { userId, isAdmin }, accessToken, "update");
    let result = false;
    if(updatedPrivacyPreferences) {
        result = true;
    }
    return result;
};